export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

// forecastly — primary brand mark used in landing top bar, auth and inside the app.
// Iter34.5 (Aug 2026): NEW logo — three yellow arrows pointing up + black wordmark.
// Displayed at ~180-250px wide on larger surfaces; keeps its native aspect ratio
// (never stretched). Replaces the previous "w_ARROW" mark.
export const FORECASTLY_LOGO_LIGHT =
  "https://customer-assets-4nw71qhi.emergentagent.net/job_cashflow-compass-13/artifacts/fm1vm4oq_forecastly%20Logo_three%20arrows%20up_LR_Aug%202026.png";
// Transparent / dark-friendly version for footers etc. Same file for now — the
// primary mark works on both light and dark backgrounds thanks to its outline.
export const FORECASTLY_LOGO_DARK =
  "https://customer-assets-4nw71qhi.emergentagent.net/job_cashflow-compass-13/artifacts/fm1vm4oq_forecastly%20Logo_three%20arrows%20up_LR_Aug%202026.png";

// ProfitMIND parent brand logo (kept for footers).
export const PROFITMIND_LOGO =
  "https://customer-assets.emergentagent.com/job_cashflow-compass-13/artifacts/e5loglbi_PROFITMIND%20Logo_Low%20Res_May%202024_WHITE%20SHADOW_BLACK_Yellow%20Bckgr.png";

// Magdalena's brand photos (uploaded by user)
export const MAGDALENA_THINKING =
  "https://customer-assets.emergentagent.com/job_cashflow-compass-13/artifacts/tanvnfu4_Photo%20of%20Me_1.jpeg";
export const MAGDALENA_LAPTOP_SMILE =
  "https://customer-assets.emergentagent.com/job_cashflow-compass-13/artifacts/0dls4jh8_Photo%20of%20Me_2.jpeg";
export const MAGDALENA_YELLOW_MUG =
  "https://customer-assets.emergentagent.com/job_cashflow-compass-13/artifacts/uuzjt2xc_Photo%20of%20Me_3.jpeg";

// Iter22: Landing "Is this for me?" section — photographer / small-shop owner
// standing at her laptop (uploaded by user).
export const HERO_PHOTO =
  "https://customer-assets.emergentagent.com/job_cashflow-compass-13/artifacts/ziir7xae_brooke-cagle-cb4Dv50LN1Y-unsplash%20copy.jpg";

export const BRAND_TAGLINE = "forecastly";

// Currency formatting
export function formatGBP(v) {
  if (v === null || v === undefined || Number.isNaN(v)) return "£0";
  const neg = v < 0;
  const abs = Math.abs(v);
  const out = new Intl.NumberFormat("en-GB", {
    style: "currency",
    currency: "GBP",
    maximumFractionDigits: 0,
  }).format(abs);
  return neg ? `−${out}` : out;
}

// Comma-separated number formatting (no currency symbol)
export function formatNum(v) {
  if (v === null || v === undefined || Number.isNaN(v) || v === "") return "";
  const n = typeof v === "string" ? Number(v.replace(/,/g, "")) : Number(v);
  if (Number.isNaN(n)) return "";
  return new Intl.NumberFormat("en-GB", { maximumFractionDigits: 0 }).format(n);
}

export function parseNum(s) {
  if (s === null || s === undefined) return 0;
  const cleaned = String(s).replace(/[,£\s]/g, "");
  const n = Number(cleaned);
  return Number.isNaN(n) ? 0 : n;
}

// Month names
export const MONTH_NAMES_FULL = [
  "January", "February", "March", "April", "May", "June",
  "July", "August", "September", "October", "November", "December",
];

export const MONTH_NAMES_SHORT = [
  "Jan", "Feb", "Mar", "Apr", "May", "Jun",
  "Jul", "Aug", "Sep", "Oct", "Nov", "Dec",
];

// Format ISO "YYYY-MM" → "June 2026"
export function formatMonthLong(iso) {
  if (!iso) return "";
  const [y, m] = iso.split("-").map(Number);
  if (!y || !m) return iso;
  return `${MONTH_NAMES_FULL[m - 1]} ${y}`;
}

export const ONBOARDING_DRAFT_KEY = "forecastly_onboarding_draft_v1";
